<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Company details</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item>
              <ion-label>Company name</ion-label>
              <ion-input
                slot="end"
                [(ngModel)]="name"
                placeholder="Pied Piper"
                (blur)="save()"
              ></ion-input>
            </ion-item>
            <!-- <ion-item>
              <ion-label position="stacked">Support phone number</ion-label>
              <ion-input [(ngModel)]="phone" placeholder="+1 (555) 555-5555"></ion-input>
            </ion-item> -->
          </ion-list>
        </ion-card>
      </ion-col>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Billing</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item *ngIf="seatsUsed > 0">
              <ion-label>Agent seats used</ion-label>
              <ion-badge color="dark" fill="outline">{{ seatsUsed }}</ion-badge>
            </ion-item>
            <ion-item>
              <ion-label>Account status</ion-label>
              <ion-badge>{{ authService.accountStatus }}</ion-badge>
            </ion-item>
          </ion-list>
          <ion-button
            size="block"
            [disabled]="isLoadingCheckout"
            *ngIf="authService.accountStatus === 'trial'"
            [routerLink]="'/upgrade'"
            routerDirection="root"
            style="margin: 10px"
          >
            <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
            <span class="text-with-left-icon">Upgrade account</span>
          </ion-button>
          <ion-button
            fill="clear"
            (click)="manageSubscription()"
            [disabled]="isLoadingCheckout"
            *ngIf="authService.accountStatus !== 'trial'"
          >
            <ion-icon
              name="card-outline"
              [hidden]="isLoadingCheckout"
            ></ion-icon>
            <ion-spinner
              name="crescent"
              [hidden]="!isLoadingCheckout"
            ></ion-spinner>
            <span class="text-with-left-icon">Manage subscription</span>
          </ion-button>
          <ion-button
            fill="clear"
            (click)="showSubscriptionOptions()"
            [disabled]="isLoadingCheckout"
          >
            <span class="text-with-left-icon">More options</span>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </ion-button>
        </ion-card>
      </ion-col>

      <!-- New section for managing owners and admins -->
      <ion-col size="12" *ngIf="authService.isTenantOwner">
        <!-- Owners section -->
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Tenant Owners</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item>
              <ion-label>
                <p>
                  Can configure all aspects of the workspace and view all data
                </p>
              </ion-label>
            </ion-item>

            <ion-item *ngFor="let owner of owners" class="user-item">
              <!-- <ion-avatar slot="start">
                <img [src]="owner.photo" [alt]="owner.name">
              </ion-avatar> -->
              <ion-label>
                <h3>{{ owner.name || owner.email }}</h3>
                <p>{{ owner.email }}</p>
              </ion-label>
              <ion-button
                fill="clear"
                size="small"
                (click)="changeRole(owner.id, owner.role)"
                [disabled]="owner.id === authService.userId"
              >
                <ion-icon name="chevron-down-outline"></ion-icon>
                Change role
              </ion-button>
            </ion-item>

            <ion-item *ngIf="owners.length === 0">
              <ion-label color="medium">No owners found</ion-label>
            </ion-item>
          </ion-list>
        </ion-card>

        <!-- Admins section -->
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Tenant Admins</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item>
              <ion-label>
                <p>Can configure all aspects of the workspace</p>
              </ion-label>
            </ion-item>

            <ion-item *ngFor="let admin of admins" class="user-item">
              <!-- <ion-avatar slot="start">
                <img [src]="admin.photo || 'assets/imgs/default-avatar.png'" [alt]="admin.name">
              </ion-avatar> -->
              <ion-label>
                <h3>{{ admin.name || admin.email }}</h3>
                <p>{{ admin.email }}</p>
              </ion-label>
              <ion-button
                fill="clear"
                size="small"
                (click)="changeRole(admin.id, admin.role)"
              >
                <ion-icon name="chevron-down-outline"></ion-icon>
                Change role
              </ion-button>
            </ion-item>

            <ion-item *ngIf="admins.length === 0">
              <ion-label color="medium">No admins found</ion-label>
            </ion-item>
          </ion-list>
        </ion-card>

        <ion-button
          fill="clear"
          [routerLink]="'/dashboard/people'"
          routerDirection="root"
          style="margin: 10px"
        >
          <ion-icon name="people-outline"></ion-icon>
          <span class="text-with-left-icon">Manage all users</span>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
